export default __webpack_public_path__ + "static/media/viber-icon.690374f4.svg";